module.exports = __webpack_public_path__ + "img/substation-img_5.57453036.png";